import { CircularProgress } from "@mui/material";
import { Colors } from "utils/colors";

export const Loader = () => (
  <div className="flex justify-center items-center h-[60vh]">
    <CircularProgress disableShrink style={{ color: Colors.green }} />
  </div>
);
